/* Keep Inbox's native, accessible launcher away from visible purchase/form controls. */
(() => {
  const mobile = matchMedia('(max-width: 749px)');
  let pending = false;
  function update() {
    pending = false;
    const host = document.querySelector('shopify-chat');
    if (!host) return;
    if (!mobile.matches) { host.style.removeProperty('--soz-chat-safe-bottom'); host.removeAttribute('data-soz-chat-clearance'); return; }
    if (host.hasAttribute('open')) return;
    const launcher = host.shadowRoot?.querySelector('[part~="activator"]');
    if (!launcher) return;
    const r = launcher.getBoundingClientRect();
    if (!r.width || !r.height) return;
    const viewport = window.visualViewport;
    const visibleBottom = viewport ? viewport.offsetTop + viewport.height : innerHeight;
    const keyboardInset = Math.max(0, innerHeight - visibleBottom);
    const protectedRects = [...document.querySelectorAll('main button, main label, main input:not([type="hidden"]), main select, main textarea, main .shopify-payment-button, footer form input:not([type="hidden"]), footer form label, footer form button')]
      .filter(el => !el.closest('[hidden]') && el.getClientRects().length)
      .map(el => el.getBoundingClientRect())
      .filter(x => x.width && x.height && x.bottom > 0 && x.top < visibleBottom && x.right > r.left - 10 && x.left < r.right + 10);
    let bottom = 20 + keyboardInset;
    // Move above the entire overlapping control; repeat if another control occupies that slot.
    for (let i = 0; i <= protectedRects.length; i++) {
      const top = innerHeight - bottom - r.height;
      const collision = protectedRects.find(x => x.top < top + r.height + 10 && x.bottom > top - 10);
      if (!collision) break;
      bottom = Math.max(bottom, innerHeight - collision.top + 12);
    }
    const cramped = bottom > 116 + keyboardInset;
    // Do not let a floating icon chase a long form halfway up the page.
    if (cramped) host.setAttribute('data-soz-chat-clearance', 'paused');
    else host.removeAttribute('data-soz-chat-clearance');
    if (cramped) bottom = 20 + keyboardInset;
    const value = `${Math.ceil(bottom)}px`;
    if (host.style.getPropertyValue('--soz-chat-safe-bottom') !== value) host.style.setProperty('--soz-chat-safe-bottom', value);
  }
  function schedule() { if (!pending) { pending = true; requestAnimationFrame(update); } }
  addEventListener('scroll', schedule, {passive: true});
  addEventListener('resize', schedule, {passive: true});
  addEventListener('focusin', schedule);
  addEventListener('focusout', schedule);
  addEventListener('load', schedule);
  mobile.addEventListener('change', schedule);
  window.visualViewport?.addEventListener('resize', schedule, {passive: true});
  window.visualViewport?.addEventListener('scroll', schedule, {passive: true});
  new MutationObserver(schedule).observe(document.body, {childList: true, subtree: true});
  schedule();
})();
